import { GlRepository } from "../repositories/GlRepository";
import { AccountTypeGroupsEntity } from "../entities/GlEntity";

/**
 * Get Account Type Groups Use Case
 * Fetches grouped account types for dropdown
 */
export class GetAccountTypeGroupsUseCase {
  constructor(private repository: GlRepository) {}

  async execute(): Promise<AccountTypeGroupsEntity> {
    return this.repository.getAccountTypeGroups();
  }
}
